import { render, staticRenderFns } from "./investigationRecords.vue?vue&type=template&id=8baf5578&scoped=true&"
import script from "./investigationRecords.vue?vue&type=script&lang=ts&"
export * from "./investigationRecords.vue?vue&type=script&lang=ts&"
import style0 from "./investigationRecords.vue?vue&type=style&index=0&id=8baf5578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baf5578",
  null
  
)

export default component.exports